import * as v from 'valibot';

export const setupValibotI18n = (): void => {
  v.setGlobalMessage('Invalid value.');
  v.setSchemaMessage('This field is required.');

  v.setSpecificMessage(v.string, 'This field is required.');
  v.setSpecificMessage(v.number, 'A number is expected.');
  v.setSpecificMessage(v.boolean, 'A boolean value is expected.');
  v.setSpecificMessage(v.bigint, 'A bigint is expected.');
  v.setSpecificMessage(v.date, 'A date is expected.');
  v.setSpecificMessage(v.array, 'An array is expected.');
  v.setSpecificMessage(v.object, 'An object is expected.');
  v.setSpecificMessage(v.literal, 'Invalid value.');
  v.setSpecificMessage(v.picklist, 'Please select a value from the list.');
  v.setSpecificMessage(v.enum, 'Invalid value.');
  v.setSpecificMessage(v.union, 'Invalid value.');

  v.setSpecificMessage(v.nonEmpty, 'This field is required.');
  v.setSpecificMessage(v.email, 'Invalid email address.');
  v.setSpecificMessage(v.url, 'Invalid URL.');
  v.setSpecificMessage(v.uuid, 'Invalid UUID.');
  v.setSpecificMessage(v.integer, 'An integer is expected.');
  v.setSpecificMessage(v.regex, 'Value does not match the required pattern.');
  v.setSpecificMessage(v.isoDate, 'Invalid date.');
  v.setSpecificMessage(v.isoDateTime, 'Invalid date and time.');
  v.setSpecificMessage(v.isoTime, 'Invalid time.');

  v.setSpecificMessage(
    v.minLength,
    (issue) => `Must be at least ${issue.requirement} characters.`,
  );
  v.setSpecificMessage(
    v.maxLength,
    (issue) => `Must be at most ${issue.requirement} characters.`,
  );
  v.setSpecificMessage(
    v.length,
    (issue) => `Must be exactly ${issue.requirement} characters.`,
  );
  v.setSpecificMessage(
    v.minValue,
    (issue) => `Minimum value is ${issue.requirement}.`,
  );
  v.setSpecificMessage(
    v.maxValue,
    (issue) => `Maximum value is ${issue.requirement}.`,
  );
  v.setSpecificMessage(
    v.minSize,
    (issue) => `Must have at least ${issue.requirement} items.`,
  );
  v.setSpecificMessage(
    v.maxSize,
    (issue) => `Must have at most ${issue.requirement} items.`,
  );
};
